import BlankLayout from '@/layouts/blank/BlankLayout.vue';
import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

/**
 * Rota PÚBLICA standalone de um artigo da Wiki — SEM login, FORA do FullLayout
 * (sem menus/sidebar do Hub). requiresAuth: false → o guard libera no passo
 * "rota pública". Só renderiza conteúdo liberado pelo endpoint público do backend
 * (published + visibility public + departamento público); o resto vira 404.
 */
export const wikiPublicRoutes: RouteRecordRaw[] = [
  {
    path: '/wiki/p/:slug',
    component: BlankLayout,
    meta: { requiresAuth: false, title: 'Artigo — Wiki' },
    children: [
      {
        path: '',
        name: 'WikiPublicArticle',
        component: () => import('@/views/Wiki/WikiPublicArticle.vue'),
        meta: { requiresAuth: false, title: 'Artigo — Wiki' },
      },
    ],
  },
];

export const wikiRoutes: RouteRecordRaw[] = [
  {
    path: '/wiki',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Wiki' },
    children: [
      { path: '', name: 'WikiHome', component: () => import('@/views/Wiki/WikiHome.vue'), meta: { requiresAuth: true, title: 'Wiki', breadcrumb: 'Wiki' } },
      { path: 'busca', name: 'WikiBusca', component: () => import('@/views/Wiki/WikiBusca.vue'), meta: { requiresAuth: true, title: 'Busca — Wiki', breadcrumb: 'Busca' } },
      { path: 'listagem', name: 'WikiListagem', component: () => import('@/views/Wiki/WikiListagem.vue'), meta: { requiresAuth: true, title: 'Artigos — Wiki', breadcrumb: 'Artigos' } },
      { path: 'artigo/novo', name: 'WikiArtigoNovo', component: () => import('@/views/Wiki/WikiEditor.vue'), meta: { requiresAuth: true, title: 'Novo artigo — Wiki' } },
      { path: 'artigo/:id/editar', name: 'WikiArtigoEditar', component: () => import('@/views/Wiki/WikiEditor.vue'), meta: { requiresAuth: true, title: 'Editar artigo — Wiki' } },
      { path: 'artigo/:id/historico', name: 'WikiHistorico', component: () => import('@/views/Wiki/WikiHistorico.vue'), meta: { requiresAuth: true, title: 'Histórico — Wiki' } },
      { path: 'admin', name: 'WikiAcessos', component: () => import('@/views/Wiki/WikiAcessos.vue'), meta: { requiresAuth: true, title: 'Administração — Wiki', breadcrumb: 'Administração' } },
      { path: ':deptSlug', name: 'WikiDept', component: () => import('@/views/Wiki/WikiDept.vue'), meta: { requiresAuth: true, title: 'Wiki' } },
      { path: ':deptSlug/:catSlug', name: 'WikiCategoria', component: () => import('@/views/Wiki/WikiCategoria.vue'), meta: { requiresAuth: true, title: 'Categoria — Wiki' } },
      { path: ':deptSlug/:catSlug/:subSlug/:articleSlug', name: 'WikiArtigo', component: () => import('@/views/Wiki/WikiArtigo.vue'), meta: { requiresAuth: true, title: 'Artigo — Wiki' } },
    ],
  },
];
export default wikiRoutes;
